import MenuInfo from "./MenuInfo";
import { Menu, MenuHandler, MenuList } from "@material-tailwind/react";
import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import * as notifyApi from "../../../service/notifyApi";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import ModalApprovePermission from "../../material/modal/ModalApprovePermission";
import moment from "moment/moment";
import { CurrentUserContext } from "../../../App";
import {
  faAngleRight,
  faBell,
  faLock,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuInfoAdmin from "../../admin/navAdmin/MenuInfo";
import MenuInfoPatient from "../../header/menuRole/menuInfoPatient";

function NavPatient(props) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [itemOnClickNotify, setItemOnClickNotify] = useState("");
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );
  const [new_notify, setNew_nottify] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentpage] = useState(0);
  const [openNotification, setOpenNotification] = useState(false);
  const [menu, setMenuItem] = useState(props.menu);
  const { hide_menu } = props;
  const [informationHover, setInformationHover] = useState(false);
  const [pharmacogenomicsHover, setPharmacogenomicsHover] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    getRequestPermission();
    // console.log(hide_menu,menu)
  }, [checkUserAfterLogin]);

  const [widtht, setWidth] = useState(0);

  const menuClick = (menu) => {
    if (menu === "home") {
      navigate("/");
    } else if (menu === "news") {
      navigate("/news");
    } else if (menu === "searchPatient") {
      navigate("/search-for-patient-information");
    } else if (menu === "about") {
      navigate("/about");
    } else if (menu === "information") {
      navigate("/information");
    } else if (menu === "contact") {
      navigate("/contact");
    } else if (menu === "login") {
      navigate("/login");
    } else if (menu === "register") {
      navigate("/register");
    } else if (menu === "ansQandA") {
      navigate("/ansQandA");
    } else if (menu === "usagePolicy") {
      navigate("/usagePolicy");
    } else if (menu === "questionnaire") {
      navigate("/questionnaire");
    }
  };

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      // console.log("updating Width");
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    const mobileDiv = document.getElementById("mobile_box_notification");
    let pageNumber = 1;
    let flag = false;
    if (mobileDiv) {
      mobileDiv.addEventListener("scroll", () => {
        const scrollY = mobileDiv.scrollTop;
        // console.log(`Scroll position: ${scrollY}px`);
        if (scrollY % 680 === 0 && !flag) {
          flag = true;
          pageNumber += 1;
          // console.log(`Page number: ${pageNumber}`);
          mobileDiv.scrollTop = 0;
        } else if (scrollY < 680 && flag) {
          flag = false;
        }
      });
    }

    const webDiv = document.getElementById("web_box_notification");
    if (webDiv) {
      webDiv.addEventListener("scroll", () => {
        const scrollY = webDiv.scrollTop;
        // console.log(`Scroll position: ${scrollY}px`);
        if (scrollY % 540 === 0 && !flag) {
          flag = true;
          pageNumber += 1;
          // console.log(`Page number: ${pageNumber}`);
          webDiv.scrollTop = 0;
        } else if (scrollY < 540 && flag) {
          flag = false;
        }
      });
    }

    // const mobileDiv = document.getElementById("box_notification");
    // let pageNumber = 1;
    // let scrollCount = 0;

    // mobileDiv.addEventListener("scroll", () => {
    //     const scrollY = mobileDiv.scrollTop;
    //     console.log(`Scroll position: ${scrollY}px`);

    //     if (scrollY % 200 === 0 && scrollY > 0) {
    //         scrollCount++;
    //         pageNumber += 1;
    //         console.log(`Page number: ${pageNumber}`);
    //     }
    // });
    // console.log(openNotification)
  }, [openNotification]);

  useEffect(() => {
    if (widtht > 767) {
      setOpen(false);
    }
  }, [widtht]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setNotifyList(res["data"]["notification_list"]);
        setNew_nottify(res["data"]["is_new_badge"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'], 'read notify')
        getRequestPermission();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  return (
    // <nav className="z-10 fixed top-0 left-0 right-0 bg-white md:h-[70px] h-28 w-full shadow-xl rounded-b-3xl flex justify-between items-center">
    //     {/* logo&appname */}
    //     <div className="flex">
    //         <button onClick={() => navigate('/patient/laboratoryresult')}>
    //             <img className="ml-[50px] lg:ml-[30px] md:ml-[20px] sm:ml-0xsm:ml-0 lg:h-[50px] md:h-[20px] sm:h-[10px]" src={require('../../../asset/image/logo.svg').default} alt=''></img>
    //         </button>
    //     </div>

    //     {
    //         openModalApprove ?
    //             <ModalApprovePermission
    //                 limitSizeHeight={'h-[auto]'}
    //                 limitSizeWeight={'w-[610px]'}
    //                 onClose={() => { setOpenModalApprove(false) }}
    //                 permission={itemOnClickNotify}
    //             /> : null
    //     }

    //     {/* mobile */}
    //     <div className='flex justify-end items-center  gap-10 invisible text-3xl absolute right-10 top-15 md:visible'>
    //         <ul onClick={() => { if (new_notify) { setReadNotification() } }}>
    //             <Menu>
    //                 <MenuHandler>
    //                     <button onClick={() => { }} className="flex h-full outline-none items-center relative">
    //                         <img onClick={() => {
    //                             setOpen(false)
    //                             setOpenNotification(!openNotification)
    //                         }} className="w-[48px] h-[48px] rounded-full lg:w-[40px] lg:h-[40px]" src="/notify.svg" alt="notify" />
    //                         {new_notify ? <>
    //                             <div className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-4 lg:h-4 text-[0.60rem] leading-tight font-medium rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF] `}></div>
    //                         </> : null}
    //                     </button>
    //                 </MenuHandler>
    //                 <MenuList className={`flex flex-col ${notifyList.length > 0 ? 'mt-7 w-[320px] rounded-2xl' : 'rounded-xl'} z-[19] `}>
    //                     <div className='h-full'>
    //                         <div id="mobile_box_notification" className={`${notifyList.length > 3 ? 'overflow-y-scroll' : 'overflow-hidden'} `}>
    //                             <div className={`${notifyList.length > 3 ? 'h-[300px]' : ''} `}>
    //                                 {notifyList.length ? <>
    //                                     {
    //                                         notifyList.map((i, idx) => (
    //                                             <div key={idx} className='m-3'>
    //                                                 <div onClick={() => {
    //                                                     if (i['payload']['type'] === 'PERMISSION') {
    //                                                         setOpenModalApprove(true)
    //                                                         setItemOnClickNotify(i['payload']['data'])
    //                                                     } else if (i['payload']['type'] === 'ALERT_LAB_INFORMATION') {
    //                                                         navigate('/patient/laboratoryresult')
    //                                                     } else {
    //                                                         console.log('ไม่รองรับ permission นี้')
    //                                                     }
    //                                                 }} className="hover:rounded-lg hover:bg-[#fdf4f0] hover:cursor-pointer p-2">
    //                                                     <div className="grid grid-cols-[auto_100px]">
    //                                                         <div className="font-bold text-[#2E2E2E]">{i['payload']['topic']}</div>
    //                                                         <div className="text-[#FFC0A4]">{moment(i['create_date']['timestamp']).format('LT') + ' ' + moment(i['create_date']?.['timestamp']).add(543, 'years').format('Do MMM')}</div>
    //                                                     </div>
    //                                                     <div className="text-[#FF9768] font-medium flex justify-start py-[5px] ">
    //                                                         {i['payload']['detail']}
    //                                                     </div>
    //                                                 </div>
    //                                                 <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
    //                                             </div>
    //                                         ))
    //                                     }
    //                                 </> : <div className="text-center text-[#2E2E2E] font-medium">ไม่พบการแจ้งเตือน</div>}
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </MenuList>
    //             </Menu>
    //         </ul>
    //         <ul>
    //             <Menu open={open}>
    //                 <MenuHandler>
    //                     <div>
    //                         {
    //                             open ? <XMarkIcon onClick={() => setOpen(!open)} className='w-6 stroke-[#FF9768] stroke-[3px]' /> : <Bars3Icon onClick={() => setOpen(!open)} className='w-6 stroke-[#FF9768] stroke-[3px]' />
    //                         }
    //                     </div>
    //                 </MenuHandler>
    //                 <MenuList className='flex flex-col items-center md:gap-y-3 gap-y-5 h-[550px] md:h-auto rounded-3xl '>
    //                     <div onClick={() => navigate('/patient/home')} className={`text-md ${menu === 'หน้าหลัก' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'}`}>หน้าหลัก</div>
    //                     <div onClick={() => navigate('/patient/laboratoryresult')} className={`text-md ${menu === 'ผลตรวจทางห้องปฏิบัติการ' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'}`}>ผลตรวจทางห้องปฏิบัติการ</div>
    //                     {/* <div onClick={() => navigate('/healthinfo')} className={`text-md ${menu === 'ข้อมูลสุขภาพของฉัน' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'}`}>ข้อมูลสุขภาพของฉัน</div> */}
    //                     <div onClick={() => navigate('/relatedinfo')} className={`text-md ${menu === 'relatedinfo' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'}`}>ข้อมูลที่เกี่ยวข้อง</div>
    //                     <div onClick={() => navigate('/patient/ans')} className={`text-md ${menu === 'ans' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} `}>คำถามที่พบบ่อย</div>
    //                     <div onClick={() => navigate('/patient/contact')} className={`text-md ${menu === 'contact' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} `}>ติดต่อเรา</div>
    //                     <div className='border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768]'></div>
    //                     <div className="flex flex-col gap-3 justify-center items-center">
    //                         <img className={user?.profile_image ? "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px] rounded-full" : "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px]"} src={user?.profile_image ? user?.profile_image : require('../../../asset/icon/iconuser.svg').default} alt="iconuser" />
    //                         <p className="text-[#FF9768] text-lg font-medium px-3 lg:text-xs">{user?.fname + ' ' + user?.lname}</p>
    //                     </div>

    //                     <div className='flex flex-col items-center gap-y-2'>
    //                         <div onClick={() => { navigate('/manageinfo') }} className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]">จัดการข้อมูลส่วนตัว</div>
    //                         <div onClick={() => { navigate('/patient/permissionAccessData') }} className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]">สิทธิ์การเข้าถึงข้อมูลของฉัน</div>
    //                         <div onClick={() => { navigate('/patient/changePassword') }} className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]">เปลี่ยนรหัสผ่าน</div>
    //                         <div onClick={() => { navigate('/patient/about') }} className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]">เกี่ยวกับเรา</div>
    //                         <div onClick={() => { navigate('/patient/questionnaire') }} className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]">แบบสอบถามจากผู้ดูแล</div>
    //                     </div>

    //                     <div
    //                         onClick={() => {
    //                             localStorage.clear()
    //                             navigate('/login')
    //                         }}
    //                         className="flex justify-center items-center bg-white rounded-full w-[120px] md:w-full h-[25px] ring-1 ring-[#FF9768]">
    //                         <img src={require("../../../asset/icon/logout.svg").default} alt="" className="mr-2 w-[12px]" />
    //                         <p className="text-[#FF9768] text-xs">ออกจากระบบ</p>
    //                     </div>
    //                 </MenuList>
    //             </Menu>
    //         </ul>
    //     </div>

    //     {/* web */}
    //     <ul className="h-12 flex items-center md:hidden">
    //         {/* หน้าหลัก */}
    //         <li>
    //             <button onClick={() =>  } className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menu === 'หน้าหลัก' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} hover:text-[#FF9768]`}>
    //                 หน้าหลัก
    //             </button>
    //         </li>
    //         {/* ผลตรวจทางห้องปฏิบัติการ */}
    //         <li>
    //             <button onClick={() => navigate('/patient/laboratoryresult')} className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menu === 'ผลตรวจทางห้องปฏิบัติการ' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} hover:text-[#FF9768]`}>
    //                 ผลตรวจทางห้องปฏิบัติการ
    //             </button>
    //         </li>
    //         {/* ข้อมูลสุขภาพของฉัน */}
    //         {/* <li>
    //             <button onClick={() => navigate('/healthinfo')} className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menu === 'ข้อมูลสุขภาพของฉัน' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} hover:text-[#FF9768]`}>
    //                 ข้อมูลสุขภาพของฉัน
    //             </button>
    //         </li> */}
    //         {/* ข้อมูลที่เกี่ยวข้อง */}
    //         <li>
    //             <button onClick={() => navigate('/relatedinfo')} className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menu === 'relatedinfo' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} hover:text-[#FF9768]`}>
    //                 ข้อมูลที่เกี่ยวข้อง
    //             </button>
    //         </li>
    //         {/* คำถามที่พบบ่อย */}
    //         <li>
    //             <button onClick={() => navigate('/patient/ans')} className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menu === 'ans' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} hover:text-[#FF9768]`}>
    //                 คำถามที่พบบ่อย
    //             </button>
    //         </li>
    //         {/* ติดต่อเรา */}
    //         <li>
    //             <button onClick={() => navigate('/patient/contact')} className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menu === 'contact' ? 'text-[#FF9768] font-bold' : 'text-[#000000]'} hover:text-[#FF9768]`}>
    //                 ติดต่อเรา
    //             </button>
    //         </li>
    //         {/* เเจ้งเตือน */}
    //         <li onClick={() => { if (new_notify) { setReadNotification() } }}>
    //             <Menu>
    //                 <MenuHandler>
    //                     <button className="flex h-full outline-none items-center mr-3 relative">
    //                         <img onClick={() => {
    //                             setOpenNotification(!openNotification)
    //                         }} className="w-[48px] h-[48px] rounded-full lg:w-[30px] lg:h-[30px]" src="/notify.svg" alt="notify" />
    //                         {new_notify ? <>
    //                             <div className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF]`}></div>
    //                         </> : null}
    //                     </button>
    //                 </MenuHandler>
    //                 <MenuList className={`${notifyList.length > 0 ? 'mt-7 w-[400px] rounded-2xl' : 'rounded-xl'} z-[19]`}>
    //                     <div id="web_box_notification" className={`${notifyList.length > 3 ? 'overflow-y-scroll' : 'overflow-hidden'} `}>
    //                         <div className={`${notifyList.length > 3 ? 'h-[300px]' : ''} `}>
    //                             {notifyList.length ? <>
    //                                 {
    //                                     notifyList.map((i, idx) => (
    //                                         <div key={idx} className='m-3'>
    //                                             <div onClick={() => {
    //                                                 if (i['payload']['type'] === 'PERMISSION') {
    //                                                     setOpenModalApprove(true)
    //                                                     setItemOnClickNotify(i['payload']['data'])
    //                                                 } else if (i['payload']['type'] === 'ALERT_LAB_INFORMATION') {
    //                                                     navigate('/patient/laboratoryresult')
    //                                                 } else {
    //                                                     console.log('ไม่รองรับ permission นี้')
    //                                                 }
    //                                             }} className="hover:rounded-lg hover:bg-[#fdf4f0] hover:cursor-pointer p-2">
    //                                                 <div className="grid grid-cols-[auto_100px]">
    //                                                     <div className="font-bold text-[#2E2E2E]">{i['payload']['topic']}</div>
    //                                                     <div className="text-[#FFC0A4]">{moment(i['create_date']['timestamp']).format('LT') + ' ' + moment(i['create_date']?.['timestamp']).add(543, 'years').format('Do MMM')}</div>
    //                                                 </div>
    //                                                 <div className="text-[#FF9768] font-medium flex justify-start py-[5px] ">
    //                                                     {i['payload']['detail']}
    //                                                 </div>
    //                                             </div>
    //                                             <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
    //                                         </div>
    //                                     ))
    //                                 }
    //                             </> : <div className="text-center text-[#2E2E2E] font-medium">ไม่พบการแจ้งเตือน</div>}
    //                         </div>
    //                     </div>
    //                 </MenuList>
    //             </Menu>
    //         </li>
    //         {/* ข้อมูลส่วนตัว */}
    //         <li>
    //             <MenuInfo />
    //         </li>

    //     </ul>
    // </nav >
    <>
      <div className="md:hidden z-[5] fixed top-0 left-0 right-0 flex justify-end bg-[#4F9C9D] text-white text-[16px] p-[5px_50px] gap-[30px]">
        <div className="flex items-center gap-[30px]">
          {!hide_menu && (
            <>
              <div
                className={`text-base cursor-pointer transition-colors duration-300 ease-in-out hover:underline ${menu === "contact" ? "font-bold underline" : "font-normal"}`}
                onClick={() => menuClick("contact")}
              >
                ติดต่อเรา
              </div>
              <div
                className={`text-base cursor-pointer transition-colors duration-300 ease-in-out hover:underline ${menu === "ansQandA" ? "font-bold underline" : "font-normal"}`}
                onClick={() => menuClick("ansQandA")}
              >
                คำถามที่พบบ่อย
              </div>
              <div
                className={`text-base cursor-pointer transition-colors duration-300 ease-in-out hover:underline ${menu === "usagePolicy" ? "font-bold underline" : "font-normal"}`}
                onClick={() => menuClick("questionnaire")}
              >
                แบบประเมินความพึงพอใจ
              </div>
            </>
          )}
        </div>
      </div>
      <div className="md:hidden lg:top-[30px] 2xl:px-5 z-[5] fixed top-[34px] left-0 right-0 flex justify-between items-center bg-white px-[50px] shadow-md w-full h-[80px]">
        <div className="2lg:gap-[12px] xxxl:gap-[20px] flex h-[80px] p-4 items-center gap-[30px] text-nowrap">
          {!hide_menu && (
            <>
              <img
                className="h-full object-cover cursor-pointer"
                src={require("../../../asset/image/logo.svg").default}
                onClick={() => menuClick("home")}
              ></img>
              <div
                className={`lg:text-sm flex text-base items-center h-[80px] cursor-pointer ${menu === "home" ? "border-b-[3px] border-b-[#43A1EF]" : "border-b-0"}`}
                onClick={() => menuClick("home")}
              >
                <div className="text-base font-bold">หน้าแรก</div>
              </div>
              {/* <div className={`lg:text-sm flex text-base items-center h-[80px] cursor-pointer ${menu === 'searchPatient' ? 'border-b-[3px] border-b-[#43A1EF]' : 'border-b-0'}`} onClick={() => menuClick('searchPatient')}>
                            <div className='text-base font-bold'>ค้นหาข้อมูลผู้ป่วย</div>
                        </div> */}
              <div
                className={`lg:text-sm flex text-base items-center h-[80px] cursor-pointer ${menu === "news" ? "border-b-[3px] border-b-[#43A1EF]" : "border-b-0"}`}
                onClick={() => menuClick("news")}
              >
                <div className="text-base font-bold">ประชาสัมพันธ์</div>
              </div>
              <div
                className={`lg:text-sm flex text-base items-center h-[80px] cursor-pointer ${menu === "about" ? "border-b-[3px] border-b-[#43A1EF]" : "border-b-0"}`}
                onClick={() => menuClick("about")}
              >
                <div className="text-base font-bold">เกี่ยวกับเรา</div>
              </div>
              <div
                className={`relative flex text-base items-center h-[80px] cursor-pointer ${menu === "information" ? "border-b-[3px] border-b-[#43A1EF]" : "border-b-0"}`}
                onClick={() => setInformationHover(!informationHover)}
              >
                <div className="text-base font-bold">ข้อมูลที่เกี่ยวข้อง</div>
                {informationHover && (
                  <div
                    className="absolute top-20 w-64 h-52 bg-white rounded-bl-md shadow-lg"
                    onMouseLeave={() => setInformationHover(false)}
                  >
                    <div className="relative">
                      <div
                        className="flex px-5 py-2 border-b border-gray-400"
                        onClick={() =>
                          navigate("/information/mapoperationRoom")
                        }
                      >
                        แผนที่ห้องปฏิบัติการที่มีในระบบ
                      </div>
                      <div
                        className="flex justify-between px-5 py-2 border-b border-gray-400"
                        onClick={() =>
                          navigate("/information/pharmacogeneticTest")
                        }
                        onMouseEnter={() => {
                          setPharmacogenomicsHover(true);
                        }}
                      >
                        <div>เภสัชพันธุศาสตร์</div>
                        <div>
                          <FontAwesomeIcon
                            icon={faAngleRight}
                          ></FontAwesomeIcon>
                        </div>
                      </div>
                      {pharmacogenomicsHover && (
                        <div
                          className="xl:-left-[285px] absolute top-0 left-64 h-52 w-auto text-nowrap bg-gray-200 rounded-br-md shadow-lg"
                          onMouseEnter={() => {
                            setPharmacogenomicsHover(true);
                          }}
                          onMouseLeave={() => {
                            setPharmacogenomicsHover(false);
                          }}
                        >
                          <div
                            className="flex px-5 py-2 border-b border-gray-400"
                            onClick={() =>
                              navigate(
                                "/information/pharmacogeneticTest/HLAB5801",
                              )
                            }
                          >
                            HLA-B*58:01
                          </div>
                          <div
                            className="flex px-5 py-2 border-b border-gray-400"
                            onClick={() =>
                              navigate(
                                "/information/pharmacogeneticTest/HLAB1502",
                              )
                            }
                          >
                            HLA-B*15:02
                          </div>
                          <div
                            className="flex px-5 py-2 border-b border-gray-400"
                            onClick={() =>
                              navigate("/information/pharmacogeneticTest/ADRs")
                            }
                          >
                            อาการไม่พึงประสงค์หลังจากการใช้ยา
                          </div>
                          <div
                            className="flex px-5 py-2 border-b border-gray-400"
                            onClick={() =>
                              navigate(
                                "/information/pharmacogeneticTest/HLAB5701",
                              )
                            }
                          >
                            HLA-B*57:01
                          </div>
                          <div
                            className="flex px-5 py-2"
                            onClick={() =>
                              navigate("/information/pharmacogeneticTest/NAT2")
                            }
                          >
                            NAT2
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        {/* web*/}
        <ul className="md:hidden 2xl:-mr-5 h-full flex items-center -mr-[50px]">
          {/* หน้าหลัก */}
          {/* เเจ้งเตือน */}
          <li
            onClick={() => {
              if (new_notify) {
                setReadNotification();
              }
            }}
          >
            <Menu>
              <MenuHandler>
                <button
                  onClick={() => {}}
                  className="flex h-full outline-none items-center mr-3 relative"
                >
                  <FontAwesomeIcon
                    icon={faBell}
                    alt="notify"
                    className="lg:w-[28px] lg:h-[28px] w-[16px] h-[18px] rounded-full"
                  />
                  {/* <img
                                        className="w-[48px] h-[48px] rounded-full lg:w-[30px] lg:h-[30px]"
                                        src="/notify.svg"
                                        alt="notify"
                                    /> */}
                  {new_notify ? (
                    <>
                      <div
                      // className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF]`}
                      ></div>
                    </>
                  ) : null}
                </button>
              </MenuHandler>
              <MenuList
                className={`flex flex-col ${notifyList.length > 0 ? "mt-7 w-80 rounded-2xl" : "rounded-xl"} z-[19]`}
              >
                {/* <div className='hover:cursor-pointer'>
                                    <div className='flex justify-center items-center gap-5'>
                                        <img className='w-10' src={require('../../../asset/icon/iconuser.svg').default} alt='' />
                                        <div className='text-[#2E2E2E] font-medium'>นาย กกกกก ขขขขขขข</div>
                                        <div className='text-[#FFC0A4]'>เวลา</div>

                                    </div>
                                    <div className='flex justify-center items-center gap-5'>
                                        <div className='text-[#FF9768]'>{'รายละเอียดแจ้งเตือน...'}</div>
                                        <div className=''>{'icon'}</div>
                                    </div>
                                </div> */}
                <div className="h-full">
                  <div
                    className={`${notifyList.length > 3 ? "overflow-y-scroll" : "overflow-hidden"}`}
                  >
                    <div
                      className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                    >
                      {notifyList.length ? (
                        <>
                          {notifyList.map((i, idx) => (
                            <button
                              key={idx}
                              className="grid py-1 rounded-lg px-[15px] w-full"
                            >
                              <div
                                onClick={() => {}}
                                className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                              >
                                <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                  <div>{i["payload"]["topic"]}</div>
                                  <div className="text-[#FFC0A4]">
                                    {i["create_date"]["time"]}
                                  </div>
                                </div>
                                <div className="text-[#FF9768] flex justify-start py-[5px]">
                                  {i["payload"]["detail"]}
                                </div>
                                <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                              </div>
                            </button>
                          ))}
                        </>
                      ) : (
                        <div className="text-center text-[#2E2E2E] font-medium">
                          ไม่พบการแจ้งเตือน
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </MenuList>
            </Menu>
          </li>
          {/* ข้อมูลส่วนตัว */}
          <li className="h-full">
            <MenuInfoPatient />
          </li>
        </ul>
      </div>
    </>
  );
}

export default NavPatient;
